import React from 'react';
import MobileHeader from "components/mobile-header";
import DashboardHeader from "components/dashboard-header";
import NotificationBar from 'components/notification-bar';
import TemplatesSidebar from 'components/template-preview';


const Templates = () => {

    return (
    <div className="w-full px-4 md:px-6 lg:px-6">
      <MobileHeader />
      
      <div className="flex items-center justify-between border-b border-solid border-brand-header-border mb-4 mt-2 lg:mt-0 pb-4 lg:pb-2.5">
        <DashboardHeader label={"Templates"} className={"xl:max-w-[850px] w-full mt-4 lg:w-full"} />
        <NotificationBar />
      </div>
      

      <TemplatesSidebar />
    </div>
  );
};

export default Templates;